import DateRangeField from '@app/components/common/date-range-field';
import { API_DATE_FORMAT } from '@app/utils';

import { FilterComponentProps } from '../../types';

export function DateRangeFilter<I extends EntityBase = EntityBase>(props: Pick<FilterComponentProps<I>, 
  'filter' | 'onChange'>) {
  const {
    filter,
    onChange,
  } = props;

  return <DateRangeField 
    id={filter.name.toString()} 
    label={filter.label} 
    value={filter.value?.length ? { startDate: filter.value[0], endDate: filter.value[1] } : undefined}   
    onChange={(value) => {
        onChange({
          ...filter,
          value: value ? [value.startDate.format(API_DATE_FORMAT), value.endDate.format(API_DATE_FORMAT)] : undefined
        });
      }}
  />;
}